import { Grid } from '@mui/material';
import ComplianceManagementGridView from './complianceManagementGrid.view';

const ComplianceManagementView = () => {
  return (
    <Grid
      container
      spacing={{ xs: 1, sm: 2 }}
      sx={{ height: '100%', overflow: 'hidden' }}
      data-testid="compliance-management-view"
    >
      <Grid item xs={12} sx={{ height: '100%', overflow: 'hidden' }}>
        <ComplianceManagementGridView />
      </Grid>
    </Grid>
  );
};

export default ComplianceManagementView;
